module.exports = __webpack_public_path__ + "media/คุกเข่าสิ่คะ.ce1b9a37.mp3";